import React, { Component, type PropsWithChildren } from 'react';
import { Result, Button } from 'antd';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

/**
 * 全局错误边界组件
 * 当渲染进程出现未捕获的 React 渲染错误时，显示友好的错误页面而非白屏
 */
export class ErrorBoundary extends Component<PropsWithChildren, ErrorBoundaryState> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // 在生产环境中，这里可以上报到日志系统
    console.error('[ErrorBoundary] Uncaught error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 48 }}>
          <Result
            status="error"
            title="页面发生异常"
            subTitle={
              import.meta.env.DEV
                ? this.state.error?.message
                : '请尝试刷新页面，如问题持续存在请联系技术支持。'
            }
            extra={[
              <Button
                key="retry"
                type="primary"
                onClick={this.handleReset}
              >
                重试
              </Button>,
              <Button
                key="reload"
                onClick={() => window.location.reload()}
              >
                刷新页面
              </Button>,
            ]}
          />
        </div>
      );
    }

    return this.props.children;
  }
}
